import { SUCCESS, FETCH_ATTENDEES, FETCH_ATTENDEE, POST_ATTENDEE_NOTES } from '../constants/actionApi';
import { UPDATE_FAV_MODEL } from '../constants/actionLocal';
import { addOrUpdateItemsInState } from '../helpers/data';
import initialState from '../store/initialState';
import { SC_ATTENDEE, UPDATED } from '../constants/socket';

export default (state = initialState.whosHereAttendees, { type, payload }) => {
  switch (type) {
    case FETCH_ATTENDEES + SUCCESS:
    case FETCH_ATTENDEE + SUCCESS:
    case POST_ATTENDEE_NOTES + SUCCESS:
      return addOrUpdateItemsInState(state, payload.data);
    case SC_ATTENDEE + UPDATED:
      return addOrUpdateItemsInState(state, payload.data);
    case UPDATE_FAV_MODEL:
      if (payload.type === 'attendee') {
        return addOrUpdateItemsInState(state, payload.data);
      } else {
        return state;
      }
    default:
      return state;
  }
};
